<template lang="html">
  <div class="content">
    <search :params.sync="params" :showCharts="showCharts" :disabled="['type']" />

    <div class="table">
      <el-table
        :data="ajaxList"
        :default-sort = "{prop: params.sort, order: params.order}"
        @row-click="rowClick">
        <el-table-column
          prop="url"
          label="URL"
          width="300">
          <template slot-scope="scope">
            <a target="_blank" :href="scope.row.url">{{scope.row.url}}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="method"
          label="请求方式">
        </el-table-column>
        <el-table-column
          prop="doc_count"
          label="异常量">
        </el-table-column>
        <el-table-column
          prop="doc_count_min"
          label="异常量/分钟">
          <template slot-scope="scope">
            <span>{{scope.row.doc_count_min ? scope.row.doc_count_min : '&lt; 0.01'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="异常描述">
          <template slot-scope="scope">
            <div class="color-danger" v-for="e in scope.row.error">
              状态异常：{{e.key}}，{{e.doc_count}}次
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="params.size"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import qs from "qs";

import search from '../../components/search';

export default {
  components: {
    search
  },
  data() {
    return {
      fullscreenLoading: false,

      ajaxList: [],
      total: 0,

      params: {},
      pagination: {
        sort: "doc_count",
        order: "descending",
        page: 1,
        size: 20
      }
    };
  },
  mounted() {

  },
  methods: {
    showCharts() {
      this.fullscreenLoading = true;
      this.fetchList().then(values => {
        this.fullscreenLoading = false;
      });
    },

    fetchList() {
      const { clientType, dateRange } = this.params;

      const { sort, order, page, size } = this.pagination;

      const query = {
        client: clientType, 
        dateRange,
        sort,
        order: order && order.replace(/ending/, ''),
        page,
        size
      };

      return axios
        .get(`/ajax/list?${qs.stringify(query)}`)
        .then(response => {
          const { data, total } = response.data;

          this.ajaxList = data;
          this.total = total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleCurrentChange(page) {
      this.params.page = page;
      this.showCharts();
    },
    rowClick(row) {
      window.location.href = `#/ajax/detail?url=${row.url}&method=${row.method}`
    }
  }
};
</script>

<style lang="css">
  .table tr {
    cursor: pointer;
  }
  .ml5 {
    margin-left: 5px;
  }
</style>

<style lang="css" scoped>
.content {
  padding: 30px;
}
.table{
  margin-top: 30px;
}
.fb{
  font-weight: bold;
}
.el-pagination{
  float: right;
  margin: 20px 0;
  padding: 0;
}
.el-icon-question{
  font-size: 16px;
}
</style>
